<template>
    <div :class="['bar', { active: theme === 1 }]">
        <div class="bar-inner" :style="barWStyle"></div>
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
    num: {
        type: Number,
        default: () => 0,
    },
    target: {
        type: Number,
        default: () => 0,
    },
    theme: {
        type: Number,
        default: () => 0,
    },
})
const barWStyle = computed(() => {
    const scale = props.num / props.target
    return {
        width: scale >= 1 ? '100%' : scale * 100 + '%',
    }
})
</script>
<style lang="scss" scoped>
.bar {
    position: relative;
    height: 10px;
    border-radius: 20px;
    background: #312443;
    overflow: hidden;

    .bar-inner {
        position: absolute;
        width: 0%;
        height: 100%;
        border-radius: 20px;
        background: linear-gradient(0deg, #fa3374 0%, #ff7aa5 100%);
    }

    &.active {
        height: 17px;
        background: rgba(28, 27, 40, 0.45);

        .bar-inner {
            background: linear-gradient(0deg, #fa3374 0%, #ff7aa5 100%);
        }
    }
}
</style>
